import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useLanguage } from '../contexts/LanguageContext'
import { languageFromPathname } from '../lib/localizedPath'

/**
 * Keeps UI language aligned with /en and /pt URL prefixes for hreflang SEO.
 */
export default function LanguageRouteSync () {
  const location = useLocation()
  const { syncLanguageFromPath } = useLanguage()

  useEffect(() => {
    const lang = languageFromPathname(location.pathname)
    if (lang) {
      syncLanguageFromPath(lang)
    }
  }, [location.pathname, syncLanguageFromPath])

  return null
}
